module.exports = __webpack_public_path__ + "img/default-BIO.e0e53217.svg";